<template>
  <svg ref="barcode" />
</template>

<script>
import JsBarcode from 'jsbarcode'

export default {
  name: 'BarCode',
  props: {
    value: {
      type: String,
      default: null
    },
    options: {}
  },
  mounted() {
    JsBarcode(this.$refs.barcode, this.value, this.options)
  }
}
</script>